import React from 'react'
import './MainService.scss';
import ServiceIcon from '../../../Assets/Images/s1.png';
import ServiceIconSec from '../../../Assets/Images/s2.png';
import ServiceIconThree from '../../../Assets/Images/s3.png';
import ServiceIconFour from '../../../Assets/Images/s4.png';
import ServiceIconFive from '../../../Assets/Images/s5.png';
import ServiceIconSix from '../../../Assets/Images/s6.png';
export default function MainService() {
    return (
        <>
            <section className="main-serivce-section-algin" id="mainpageservice">
                <div className="container">
                    <div className="service-title">
                        <p>WHAT WE OFFER</p>
                        <h2>Our Main Services</h2>
                        <span>
                            At CoreAI, we offer a suite of services to help 
                            business owners grow digitally. Our services include AI, data science,<br/>
                             machine learning and web application development. 
                        </span>
                    </div>
                    <div className="main-service-grid">
                        <div className="main-service-grid-items">
                            <div className="service-card">
                                <div className="provide-service">
                                    <img src={ServiceIcon} alt="ServiceIcon"/>
                                </div>
                                <div className="service-details">
                                    <p>Face Recognation</p>
                                    <span>
                                        Computer vision plays a role in more aspects of our day-to-day lives than we might think. There are applications that touch 
                                        our lives from detecting unauthorized use of an image to identifying people’s emotions.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-service-grid-items">
                            <div className="service-card">
                                <div className="provide-service">
                                    <img src={ServiceIconSec} alt="ServiceIconSec"/>
                                </div>
                                <div className="service-details">
                                    <p>Natural Language Processing</p>
                                    <span>
                                        Natural language processing (NLP) is a field of artificial intelligence focused on developing technology that allows 
                                        computers to analyse, understand, and derive meaning from human language in a smart way. 
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-service-grid-items">
                            <div className="service-card">
                                <div className="provide-service">
                                    <img src={ServiceIconThree} alt="ServiceIconThree"/>
                                </div>
                                <div className="service-details">
                                    <p>Machine Learning</p>
                                    <span>
                                        Businesses are integrating Machine Learning into their strategy for success. It's a 
                                        fast growing field that has many positive effects on businesses. Machine Learning is an automated process of searching for patterns in data
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-service-grid-items">
                            <div className="service-card">
                                <div className="provide-service">
                                    <img src={ServiceIconFive} alt="ServiceIconFive"/>
                                </div>
                                <div className="service-details">
                                    <p>Deep Learning</p>
                                    <span>
                                        Deep learning is a type of computer vision and machine learning. Image recognition is one example of a use of deep learning. The aim of this technique 
                                        is to increase the capability of computers by testing their understanding and abilities with huge volumes of data.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-service-grid-items">
                            <div className="service-card">
                                <div className="provide-service">
                                    <img src={ServiceIconFour} alt="ServiceIconFour"/>
                                </div>
                                <div className="service-details">
                                    <p>Chat Bot</p>
                                    <span>
                                        Chatbots can automate tasks that previously required human interaction. They can help grow your business by offering helpful suggestions and information. A chatbot can also help you 
                                        stay motivated. Simply install the chatbot on your site and start receiving responses from your clients right on their phone. 
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="main-service-grid-items">
                            <div className="service-card">
                                <div className="provide-service">
                                    <img src={ServiceIconSix} alt="ServiceIconSix"/>
                                </div>
                                <div className="service-details">
                                    <p>Sentiment Analysis</p>
                                    <span>
                                        Sentiment Analysis is a process that looks at a site’s social media presence, 
                                        product reviews, and customer reviews to identify whether a client is positive or negative towards a business. 
                                        Have you ever wondered how to interpret the emotional impact of a review on your business.
                                    </span>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </section>   
        </>
    )
}
